import { render, staticRenderFns } from "./SearchUserProfit.vue?vue&type=template&id=2ee7c7b0&scoped=true&"
import script from "./SearchUserProfit.vue?vue&type=script&lang=js&"
export * from "./SearchUserProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee7c7b0",
  null
  
)

export default component.exports